module.exports = __webpack_public_path__ + "static/media/beru-whitesun-lars.bd867396.jpg";